// extracted by mini-css-extract-plugin
export var anticlockwise = "bv_fF";
export var svg = "bv_fC";
export var wrapper = "bv_C";
export var wrapperFlexCenter = "bv_fD";